import { useState } from "react";
import {
  formatImage,
  formatStatus,
  formatActions,
  formatProdInfo
} from "./Formatters";

const ListingMobileCard = ({ item }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="listing-card mb-2 p-2 border rounded">

      {/* HEADER (tap zone) */}
      <div
        className="d-flex gap-2"
        onClick={() => setExpanded(prev => !prev)}
        style={{ cursor: "pointer" }}
      >

        <div className="flex-grow-1 left">
          <div className="actions mb-2 small" onClick={(e) => e.stopPropagation()}>
            {formatActions(item)}
          </div>
          <div className="img mb-2">
                {formatImage(item.img)}
          </div>
          <div className="status"> {formatStatus(item.status)} </div>
        </div>

        <div className="flex-grow-1">
          <div className="fw-semibold mb-1 title">
            {item.title}
          </div>

          <div className="text-muted small">
            {item.asin} {item.fnsku ? '| '+item.fnsku : '' }
            <br/>
            {item.sku}
          </div>

          <div className="d-flex gap-2 small mt-1">
            <span><strong>Price:</strong> <span className="price"> {item.price}</span></span>
            <span><strong>Sales:</strong> <span className="sales"> {item.sales}</span></span>
          </div>
        </div>

        <div className="ms-auto">
          {expanded ? "▾" : "▸"}
        </div>
      </div>

      {/* EXPANDED */}
      {expanded && (
        <div className="mt-2 pt-2 border-top small">
          <div className="d-flex flex-wrap gap-2">
            <span><strong>FBA Fee:</strong> <span className="fee"> {item.fee}</span></span>
            <span><strong>Sessions:</strong> <span className="sessions"> {item.sessions}</span></span>
            <span><strong>Stock:</strong> <span className="stock">{item.stock}</span></span>
            <span><strong>Inbound:</strong> <span className="inbound">{item.inbound}</span></span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListingMobileCard;
